import { render, staticRenderFns } from "./AddAssetsCategory.vue?vue&type=template&id=d7819f24&"
import script from "./AddAssetsCategory.vue?vue&type=script&lang=js&"
export * from "./AddAssetsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports